// Quality settings — purely cosmetic. Never touches gameplay.
//
// Setting values: "auto" | "high" | "low"
// "auto" picks high on desktop / low on mobile based on a simple heuristic.
// User can override via the Menu's Quality button.
//
// Effective config (what the renderer reads):
//   - shadows         : Canvas `shadows` prop
//   - dpr             : Canvas `dpr` prop (lower = fewer pixels rendered)
//   - antialias       : gl.antialias
//   - groundTextureSize : MapScene canvas texture resolution (1024 vs 384)
//   - particleScale   : multiplier on counts of decorative particles/stars
const KEY = "zombieCollector3D_quality_v1";

export const QUALITY_OPTIONS = ["auto", "high", "low"];

export function loadQuality() {
  try {
    const v = localStorage.getItem(KEY);
    return QUALITY_OPTIONS.includes(v) ? v : "auto";
  } catch {
    return "auto";
  }
}

export function saveQuality(q) {
  try {
    if (QUALITY_OPTIONS.includes(q)) localStorage.setItem(KEY, q);
  } catch {
    // ignore — localStorage may be disabled
  }
}

// Resolve "auto" → "high" | "low" using a cheap device sniff. Runs once on
// Game mount; never inside useFrame.
function detectAuto() {
  if (typeof window === "undefined" || typeof navigator === "undefined") return "high";
  // Coarse pointer = mostly touch device.
  const isCoarse = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
  // Mobile UA hint.
  const isMobileUA = /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
  // Narrow viewport.
  const isNarrow = window.innerWidth < 720;
  // Low memory hint (Chrome/Android).
  const lowMem = (navigator.deviceMemory || 8) < 4;
  if (isCoarse || isMobileUA || isNarrow || lowMem) return "low";
  return "high";
}

export function resolveQuality(setting) {
  if (setting === "high" || setting === "low") return setting;
  return detectAuto();
}

// Render-time config consumed by Canvas + MapScene + Scene.
export function getQualityConfig(setting) {
  const eff = resolveQuality(setting);
  if (eff === "low") {
    return {
      effective: "low",
      shadows: false,
      dpr: [1, 1],
      antialias: false,
      groundTextureSize: 384,
      particleScale: 0.55,
    };
  }
  return {
    effective: "high",
    shadows: true,
    dpr: [1, 1.5],
    antialias: true,
    groundTextureSize: 1024,
    particleScale: 1,
  };
}
